import gqlsuspense from "graphql-suspense";
import React, { useEffect, useState } from "react";
import { client } from "../../../../services/constants";
import { GET_ORDERING_GUIDE } from "../../../../services/graphql-query";

export default function OrderingGuideTable({ collectionName }) {
    const [data, setData] = useState([]);

    const orderingGuide = gqlsuspense(
        client.query,
        {
            query: GET_ORDERING_GUIDE,
        },
        { name: collectionName }
    );

    useEffect(() => {
        const merged = [];
        orderingGuide.data.collections.data[0].attributes.ordering_guide.map(
            (item) => {
                merged.push(item.values.split("\n"));
            }
        );
        setData(merged);
    }, []);

    return (
        <div className="my-4">
            <h2 className="text-uppercase fw-bold">Ordering Guide</h2>
            <p className="lead">
                <span className="fw-bold">Example: </span>
                AXL80-50K-BLK-TYPEIII-A-SP-PC-LV
            </p>

            <div
                style={{
                    minHeight:
                        orderingGuide.data.collections.data[0].attributes
                            .ordering_guide.length !== 0 && "300px",
                }}
                className="table-responsive-xl"
            >
                {orderingGuide.data.collections.data[0].attributes
                    .ordering_guide.length === 0 ? (
                    <div className="d-flex align-items-center justify-content-center">
                        <p className="lead">
                            There is no ordering guide for this product
                        </p>
                    </div>
                ) : (
                    <table className="table table-layout">
                        <>
                            <thead className="text-center">
                                <tr>
                                    {orderingGuide.data.collections.data[0].attributes.ordering_guide.map(
                                        (item) => {
                                            return (
                                                <th scope="col">
                                                    <div
                                                        className={`d-flex align-items-center px-lg-1 px-xl-5 px-xxl-5 h-100 ${
                                                            item.header.split(
                                                                "' '"
                                                            ).length > 1
                                                                ? "justify-content-between"
                                                                : "justify-content-center"
                                                        }`}
                                                    >
                                                        {item.header
                                                            .split("' '")
                                                            .map((h) => {
                                                                return (
                                                                    <div>
                                                                        {h}
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </th>
                                            );
                                        }
                                    )}
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {data.length > 0 &&
                                    [
                                        ...Array(
                                            Math.max(
                                                ...data.map((el) => el.length)
                                            )
                                        ),
                                    ].map((_, i) => {
                                        return (
                                            <tr>
                                                {data.map((item) => {
                                                    if (item[i])
                                                        return (
                                                            <td
                                                                style={{
                                                                    height: "1px",
                                                                }}
                                                            >
                                                                <div
                                                                    className={`d-flex align-items-center px-lg-1 px-xl-5 px-xxl-5 h-100 ${
                                                                        item[
                                                                            i
                                                                        ].split(
                                                                            "' '"
                                                                        )
                                                                            .length >
                                                                        1
                                                                            ? "justify-content-between"
                                                                            : "justify-content-center"
                                                                    }`}
                                                                >
                                                                    {item[i]
                                                                        .split(
                                                                            "' '"
                                                                        )
                                                                        .map(
                                                                            (
                                                                                w,
                                                                                i
                                                                            ) => {
                                                                                return (
                                                                                    <div
                                                                                        className={`${
                                                                                            i ===
                                                                                                0 &&
                                                                                            "fw-bold"
                                                                                        }`}
                                                                                    >
                                                                                        {
                                                                                            w
                                                                                        }
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                </div>
                                                            </td>
                                                        );
                                                    else return <td></td>;
                                                })}
                                            </tr>
                                        );
                                    })}

                                {/* <tr>
                        <td style={{ height: "1px" }}>
                            <div className="d-flex align-items-center justify-content-between px-lg-3 px-xl-5 h-100">
                                <div className="fw-bold">AXL80</div>
                                <div>80W</div>
                            </div>
                        </td>
                        <td style={{ height: "1px" }}>
                            <div className="d-flex align-items-center justify-content-between px-lg-3 px-xl-5 h-100">
                                <div className="fw-bold">40K</div>
                                <div>4000K</div>
                            </div>
                        </td>
                        <td style={{ height: "1px" }}>
                            <div className="d-flex align-items-center justify-content-between px-lg-3 px-xl-5 h-100">
                                <div className="fw-bold">BLK</div>
                                <div>BLACK</div>
                            </div>
                        </td>
                        <td style={{ height: "1px" }}>
                            <div className="d-flex align-items-center justify-content-center h-100">
                                <div className="fw-bold">60°</div>
                            </div>
                        </td>
                        <td>
                            <div className="d-flex align-items-center px-lg-3 px-xl-5">
                                <div className="fw-bold col-4">SP</div>
                                <div className="col-8 text-start">
                                    20KV SURGE SUPPRESSION
                                </div>
                            </div>
                        </td>
                    </tr>
                   */}
                            </tbody>
                        </>
                    </table>
                )}

                <div className="row">
                    <div className="col-4"></div>
                    <div className="col-8">
                        <div className="d-flex justify-content-start">
                            <p className="fw-bold me-3">NOTE:</p>
                            <p>
                                All Mounting Brackets, Photocells, Surge
                                Suppressor and HV input are standard options and
                                included in pricing. USPOM Fixtures come with a
                                10 Year Limited Warranty.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
